import { gql } from '@apollo/client';

export const GET_BELEGUNGEN = gql`
  query dienstplan_getBelegungen($tag: dienstplan_tag!, $standortId: String!) {
    dienstplan_findAllBelegungen(standortId: $standortId, tage: [$tag]) {
      anzahlMitarbeiter
      arbeitsbereich {
        id
        markierung
        name
      }
      dauer
      id
      wochentag
      von
    }
  }
`;
